import React from 'react';
import ImageUploader from '../../../Shared/ImageUploader';
import classes from './LogoWebsite.module.css';
import Button from '../../../Shared/Forms/Button';
import { useAppContext } from '../../../../Context/AppContext';
import Input from '../../../Shared/Forms/Input';
import { replaceValueForKey } from '../../../../Utility';
import ReactGA from 'react-ga';
import { Activity, ActivityString, currentRequestTimeStamp } from '../../../../Constants';
import { toast } from 'react-toastify';
import mixpanel from 'mixpanel-browser'
import { Urls } from '../../../../Urls';

const LogoWebsite = () => {
  const { isEditable, transporterInfo } = useAppContext();

  return (
    <div className={classes.container}>
      <div className={classes['inner-container']}>
        {isEditable ? (
          <EditMode transporterInfo={transporterInfo} />
        ) : (
            <ReadOnly {...transporterInfo} />
          )}
      </div>
    </div>
  );
};

const ReadOnly = ({ logo, website }) => (
  <>
    <div className={classes['logo-container']}>
      <ImageUploader fileId={logo} />
    </div>
    <Website isEditEnabled={false} webUrl={website} />
  </>
);

const EditMode = ({ transporterInfo }) => (
  <>
    <div className={classes['logo-container']}>
      <ImageUploader
        fileId={transporterInfo.logo}
        isEditable
        onUpload={(imageId) => {
          transporterInfo.logo = imageId;
          toast.success('Logo Uploaded')
        }}
        transporterId={transporterInfo.transporter_id}
        containerClassName={classes.logo}
      />
    </div>
    <Website
      isEditEnabled
      webUrl={transporterInfo.website}
      transporterInfo={transporterInfo}
    />
  </>
);

const Website = ({ isEditEnabled, webUrl, transporterInfo }) => {
  const onClick = () => {
    ReactGA.event({
      category: transporterInfo?.transporter_name,
      action: 'Website button pressed in TPMP'
    });
    Activity([{ "screen": "General Information", "module": "Financials Tab", "user_activity": ActivityString.Website, "timestamp": currentRequestTimeStamp() }])
    ReactGA.event({
      category: 'TPMP',
      action: `${transporterInfo?.transporter_name},website button,,,TPMP, General Information, ${Date(24 * 3600 * 1000)}`
    });
    let checkForUrl = webUrl.includes("https://", 0);
    let checkForUrlhttp = webUrl.includes("http://", 0);
    if(checkForUrl===true){
      let result = webUrl.replace("https://", "");
      window.open(`http://${result}`, '_blank', 'noopener');
    }
    else if(checkForUrlhttp === true){;
      window.open(webUrl, '_blank', 'noopener');
    }
    else{
      window.open(`http://${webUrl}`, '_blank', 'noopener');
    }
    mixpanel.track('User has clicked on website button', {
      // distinct_id: 'unique client id',
      ApplicationName: `${Urls.appnamemixpanel}`,
      ScreenName: 'Transporter-Profile',
      ModuleName: 'general-information',
      ActivityLog: 'userClickedWebsiteButton',
      Data: 'None',
      Definition: 'User has clicked on website button',
      TransporterName: transporterInfo?.transporter_name,
      TransporterId:transporterInfo?.transporter_id,
      ActivityType: 'event_view'
    });
  };

  const disabled = !webUrl || !webUrl.trim();

  return (
    <>
      {isEditEnabled ? (
        <Input
          placeholder="Website"
          defaultValue={webUrl}
          onChange={value =>
            replaceValueForKey(transporterInfo, 'website', value)
          }
          className={classes['website-input']}
        />
      ) : (
          <Button title="Website" onClick={() => !disabled && onClick()} disabled={disabled} />
        )}
    </>
  );
};

export default LogoWebsite;
